import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

const { FiClock, FiEye } = FiIcons;

function ArticleCard({ article, index = 0, showTags = false, headingLevel = 3 }) {
  const navigate = useNavigate();
  const Heading = `h${headingLevel}`;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.4 }}
      onClick={() => navigate(`/${article.slug}`)}
      className="card overflow-hidden cursor-pointer group transition-all duration-300 hover:shadow-2xl"
      role="article"
      tabIndex={0}
      onKeyPress={(e) => {
        if (e.key === 'Enter') navigate(`/${article.slug}`);
      }}
    >
      {/* Image */}
      <div className="relative h-48 overflow-hidden">
        <img
          src={article.image}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute top-4 left-4">
          <span className="px-3 py-1 bg-rose-500 text-white text-sm rounded-full font-medium shadow-lg">
            {article.category}
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="p-6">
        <Heading className="text-xl font-bold text-slate-900 dark:text-white mb-3 line-clamp-2 group-hover:text-rose-500 transition-colors duration-300">
          {article.title}
        </Heading>
        <p className="text-slate-600 dark:text-slate-400 text-sm mb-4 line-clamp-3">
          {article.excerpt}
        </p>

        {/* Meta Info */}
        <div className="flex items-center justify-between text-sm text-slate-500 dark:text-slate-400 pt-4 border-t border-slate-100 dark:border-slate-700">
          <div className="flex items-center gap-4">
            <span className="flex items-center gap-1">
              <SafeIcon icon={FiClock} className="w-4 h-4" />
              {article.readTime}
            </span>
            <span className="flex items-center gap-1">
              <SafeIcon icon={FiEye} className="w-4 h-4" />
              {article.views}
            </span>
          </div>
        </div>

        {/* Tags (Optional) */}
        {showTags && article.tags && (
          <div className="flex flex-wrap gap-2 mt-4">
            {article.tags.slice(0, 3).map((tag) => (
              <span
                key={tag}
                className="px-2 py-1 bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-400 text-xs rounded-md"
              >
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </motion.div>
  );
}

export default ArticleCard;